import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Mirrors backend DEFAULT_CONFIG in routes/site_config.py — rendered at build time (pre-render)
// and as the instant first paint; the live admin-edited config replaces it on load.
const slugify = (l) => l.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 60);
const SERVICES = [
  ["Junk Removal", false], ["Deep Cleaning", false], ["Move-Out Cleaning", false], ["Carpet Cleaning", false],
  ["Whole House Cleanout", false], ["Declutter", false],
  ["Routine Cleaning", true], ["Commercial Cleaning", true], ["Estate Cleanouts", true], ["Pressure Washing", true],
  ["Painting", true], ["Handyman Services", true], ["Flooring", true], ["Drywall", true], ["Carpentry", true],
  ["Landscaping", true], ["Property Maintenance", true], ["Roofing & Windows", true], ["Virtual & Admin Services", true],
  ["Other (I'll explain in notes)", false],
];

export const DEFAULT_HOMEPAGE_CONFIG = {
  services: SERVICES.map(([label, strip]) => ({ slug: label.startsWith("Other") ? "other" : slugify(label), label, strip })),
  core_services: [
    { slug: "junk-removal", title: "Junk Removal", desc: "Furniture, appliances, garage and basement cleanouts, construction debris. We do all the lifting.", price: "From $125", href: "/junk-removal" },
    { slug: "deep-cleaning", title: "Deep Cleaning", desc: "Baseboards, grout, fixtures, cabinet fronts, window tracks — the buildup routine cleaning never reaches.", price: "From $200", href: "/deep-cleaning" },
    { slug: "move-out-cleaning", title: "Move-Out Cleaning", desc: "Deposit-ready. Inside cabinets, inside appliances, every surface, top to bottom.", price: "", href: "/move-out-cleaning" },
    { slug: "carpet-cleaning", title: "Carpet Cleaning", desc: "Deep extraction, stain treatment, and odor elimination — including pet and smoke odor.", price: "", href: "/carpet-cleaning" },
    { slug: "whole-house-cleanout", title: "Whole House Cleanout", desc: "Clear it out, deep clean it, treat the carpets. One crew, usually one day.", price: "", href: "/fresh-start" },
    { slug: "declutter", title: "Declutter", desc: "Judgment-free help getting a space back. You decide what stays, we handle the rest.", price: "", href: "/hoarding-cleanup" },
  ],
};

export const quoteHrefForService = (slug) => `/?service=${encodeURIComponent(slug)}#quote`;
export const PRESELECT_EVENT = "hcob:preselect-service";

// Same-page deep link: pre-select in the form, update the URL, smooth-scroll — no reload.
export function jumpToQuote(e, slug) {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  const form = document.getElementById("quote");
  if (!form) return; // other page → let the browser follow the href
  e.preventDefault();
  window.dispatchEvent(new CustomEvent(PRESELECT_EVENT, { detail: slug }));
  window.history.replaceState(null, "", quoteHrefForService(slug));
  form.scrollIntoView({ behavior: "smooth", block: "start" });
}

let cache = null;
export function useHomepageConfig() {
  const [cfg, setCfg] = useState(cache || DEFAULT_HOMEPAGE_CONFIG);
  useEffect(() => {
    if (cache) return;
    api.get("/site/homepage").then(({ data }) => {
      if (data?.services?.length && data?.core_services?.length) { cache = data; setCfg(data); }
    }).catch(() => {});
  }, []);
  return cfg;
}
